export const SELF_IDENTIFICATION_OPTIONS = [
    { label: "Creator", value: "Creator" },
    { label: "Agency", value: "Agency" },
    { label: "Blogger", value: "Blogger" },
    { label: "Community Owner", value: "Community Owner" },
    { label: "Educator", value: "Educator" },
    { label: "Other", value: "Other" },
];

export const EXPERIENCE_LEVEL_OPTIONS = [
    { label: "Beginner", value: "Beginner" },
    { label: "Intermediate", value: "Intermediate" },
    { label: "Advanced", value: "Advanced" },
];
export const AUDIENCE_SIZE_OPTIONS = [
    { label: "<1k", value: "<1k" },
    { label: "1k-10k", value: "1k-10k" },
    { label: "10k-50k", value: "10k-50k" },
    { label: "50k-200k", value: "50k-200k" },
    { label: "200k+", value: "200k+" },
];

export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;